var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn1",class:[_vm.Class],attrs:{"href":_vm.href}},[_vm._v(_vm._s(_vm.btnbrownText))])])}
var staticRenderFns = []

export { render, staticRenderFns }